function buildEmbroideryItems(
  previewUrl,
  designId
) {

  const items = [];

  const baseVariant =
    getBaseVariantId();

  const properties =
  getEmbroideryProperties();

properties["_builderId"] =
  designId;

properties["Preview Image"] =
  previewUrl;

items.push({
  id: Number(baseVariant),
  quantity: 1,
  properties
});

  const upgrades =
    window.getSelectedEmbroideryVariants();

  upgrades.forEach(id => {

    items.push({
      id: Number(id),
      quantity: 1
    });

  });

  return items;

}

document.addEventListener(
  "DOMContentLoaded",
  () => {

    const addBtn =
  document.getElementById(
    "addToCartBtn"
  );

    if (!addBtn) return;

    addBtn.addEventListener(
  "click",
  async () => {

    try {

      const designId =
        Date.now().toString(36) +
        Math.random().toString(36).slice(2);

      const blob =
        await window.EMBThumbnail.generateBlob();
        const debugUrl = URL.createObjectURL(blob);

const img = document.createElement("img");

img.src = debugUrl;

img.style.position = "fixed";
img.style.top = "20px";
img.style.right = "20px";
img.style.width = "300px";
img.style.zIndex = "999999";
img.style.border = "3px solid red";

document.body.appendChild(img);

      const previewUrl =
        await window.EMBUpload.upload(
          blob,
          designId
        );

      const items =
        buildEmbroideryItems(
          previewUrl,
          designId
        );

      console.log(
        "SUBMITTING:",
        items
      );

          const response =
            await fetch(
              "/cart/add.js",
              {
                method: "POST",
                headers: {
                  "Content-Type":
                    "application/json"
                },
                body:
                  JSON.stringify({
                    items
                  })
              }
            );

          const data =
            await response.json();

          console.log(
            "SUCCESS:",
            data
          );

          document.dispatchEvent(
            new CustomEvent(
              "cart:refresh"
            )
          );

          document.dispatchEvent(
            new CustomEvent(
              "cart:open"
            )
          );

        } catch(err) {

  console.error(
    "EMBROIDERY ADD TO CART FAILED:",
    err
  );

}

      }
    );

  }
);